import React, { useState } from "react";

export const VideoThumbnails = ({ videos }) => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (video) => {
    setSelectedVideo(video);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
  };

  return (
    <div className="p-4">
      {/* Thumbnails List */}
      <div className="flex space-x-4 overflow-x-auto">
        {videos.map((video) => (
          <div
            key={video}
            onClick={() => openModal(video)}
            className="flex-shrink-0 cursor-pointer"
          >
            <img
              src={`https://img.youtube.com/vi/${video}/default.jpg`}
              alt=""
              className="h-30 w-auto rounded-lg shadow-md hover:shadow-lg transition-shadow"
            />
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && selectedVideo && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl relative" style={{ height: '50vh' }}>
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-700 hover:text-gray-900"
            >
              &times;
            </button>
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${selectedVideo}`}
              title={selectedVideo}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="rounded-lg"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};